import React, { use, useEffect, useState, useRef } from 'react';
import i18n from '../../i18n/i18n.js';
import { ReactSVG } from "react-svg";
import { Utils } from '../../Utils.js';
import { AppContext, useAppContext } from '../../contexts/AppContext.js';

const FavoriteIcon = ({product,className,on_change}) => {

    const { appRef } = useAppContext();
    // lokális állapot: így a szív azonnal átvált kattintásra (az appRef nem reaktív)
    const [is_favorite, setIsFavorite] = useState(appRef.current.is_favorite_product(product));
    const class_name = className ?? 'fav';

    function fire_on_change(res, changed_product) {
        if (typeof on_change === 'function') {
            on_change(changed_product, !is_favorite);
        }
    }

    function handle_fav_click(e) {

        e.preventDefault();
        e.stopPropagation();

        if(is_favorite)
        {
            setIsFavorite(false);
            appRef.current.product_fav_delete(e,{product, on_resolve: fire_on_change});
        }
        else
        {
            // nem bejelentkezett esetben a product_fav_add amúgy sem ad hozzá, ne váltson a szív
            if(!appRef.current.get_is_signed())
            {
                appRef.current.product_fav_add(e,{product});
                return;
            }

            setIsFavorite(true);
            appRef.current.product_fav_add(e,{product, on_resolve: fire_on_change});
        }

    }

    return <>
        <ReactSVG onClick={handle_fav_click} className={class_name} src={`/assets/images/${is_favorite ? 'favorites_on' : 'favorites_off'}.svg`}></ReactSVG>
    </>
}

export default FavoriteIcon;